import { useQuery, UseQueryResult } from 'react-query';
import { SuspicionItemEntity } from '_types';
import { suspicions } from '../../services/nestApiService';
import { ReportFiltersWithPaging } from '../../features/dashboard/Overview/ReportCard';
import { Paging } from 'src/services/dataService';

export const useSuspicionsReportEntityQuery = (
  targetId: string,
  suspicionId: string,
  filters: ReportFiltersWithPaging,
): UseQueryResult<{ entities: SuspicionItemEntity[]; paging: Paging }> =>
  useQuery(
    [
      'target',
      targetId,
      'suspicion-reports-entities',
      suspicionId,
      'filters',
      filters,
    ],
    () => suspicions.entities.list(targetId, suspicionId, filters),
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  );
